<template>
  <div class="pa-10">
    <StudentSubmissionUtilDataTableVue />
  </div>
</template>

<script>
import StudentSubmissionUtilDataTableVue from "../../components/Utils/StudentSubmissionUtilDataTable.vue";

export default {
  name: "StudentRequirementPage",
  components: {
    StudentSubmissionUtilDataTableVue,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
